export default __webpack_public_path__ + "static/cholera-e8ae4d6ff0f1ea2ea567a6d40aeb9b44.png";